/* global */
import React, {Fragment} from "react";
import ReactClass from "create-react-class";
import PropTypes from "prop-types";
import {WidgetPanel, AsSubscribedComponent} from "ui-dashboard";
import {ProgressBar} from "../../../../../components/widgets";
import Config from "../../../../../config";

const widgetPath = `${Config.baseDir}modules/enduser-app/dashboard/widgets/air-filter`,
    Keys = {
      IS_ON: "air_filter_on",
      END_DATE: "air_filter_end_date",
      PERCENT_REMAINING: "air_filter_pct_remaining"
    },
    getDaysRemaining = strDate => {
      if (!strDate) {
        return "Unknown";
      }
      const targetDate = new Date(strDate), targetTime = targetDate.getTime();
      if(isNaN(targetTime)) {
        return "Unknown";
      }
      return Math.floor((targetTime - new Date().getTime()) / 1000 / 60 / 60 / 24);
    },
    Widget = AsSubscribedComponent(ReactClass({
      displayName: "AirFilterWidget",
      propTypes: {
        thresholdMin: PropTypes.number.isRequired,
        title: PropTypes.string,
        icon: PropTypes.string,
        iconDisabled: PropTypes.string
      },
      getInitialState() {
        return {};
      },
      componentDidUpdate() {
        this.props.layout.layout();
      },
      render() {
        const {Header, Content} = WidgetPanel,
            {
              title = "Air Purification",
              icon = `${widgetPath}/airFilter.png`,
              iconDisabled = icon,
              panelClass = ""
            } = this.props,
            {disabled} = this.state,
            renderedIcon = disabled ? iconDisabled : icon,
            {data} = this.state,
            {
              thresholdMin = Number.NEGATIVE_INFINITY
            } = this.props,
            daysRemaining = data ? data.daysRemaining : 0,
            hasAlert = data && daysRemaining < thresholdMin;

        let content;
        if(hasAlert) {
          content = this.renderAlert();
        }else {
          content = this.renderValue();
        }

        return (
          <WidgetPanel {...this.props}
            panelClass={`air-filter ${panelClass} ${hasAlert ? "alert-on" : ""}`}>
            <Header>
              <img className="icon" src={renderedIcon} alt="Icon" />
              <span className="title">{title}</span>
            </Header>
            <Content>
              {content}
            </Content>
          </WidgetPanel>
        );
      },
      renderAlert() {
        const {alertMessage = "Alert!! Replace!"} = this.props;
        return (
          <div className="message">
            <i className="icon icon-alert-triangle"></i>
            <p className="">{alertMessage}</p>
          </div>
        );
      },
      renderValue() {
        const {data} = this.state,
            value = data ? data.daysRemaining : "...",
            isOn = data ? data.isOn : false,
            percentValue = data ? data.percentRemaining : 0;
        return (
          <Fragment>
            <div className="value">{isOn ? "On" : "Off"} ({value} Days)</div>
            <ProgressBar value={percentValue} />
          </Fragment>
        );
      },
      onData(data, channel) {
        if(!data) {
          return;
        }

        const daysRemaining = getDaysRemaining(data[Keys.END_DATE]);
        this.setState({
          channel: channel,
          data: {
            daysRemaining,
            isOn: data[Keys.IS_ON],
            percentRemaining: data[Keys.PERCENT_REMAINING]
          }
        });
      }
    })),

    Info = {
      id: "eua-dashboard:air-filter",
      name: "Air Filter Widget",
      description: "Enduser app dashboard air filter widget",
      type: Widget
    };

export default {
  Info,
  Widget
};
